var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-card')],1),_c('v-col',{attrs:{"cols":"9"}},[_c('v-card',[_c('formqueue'),(_vm.RecordItem.name !== 'Select a record item to view')?_c('RecordNode',{attrs:{"RecordItem":_vm.RecordItem,"isRoot":true}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }